export const VARIATION_PROFILES = ['thunderbird', 'outlook', 'applemail', 'iphonemail'];

const trimHeaderField = (value) => String(value || '').trim();

const firstNonEmptyHeaderField = (...values) => {
  for (const value of values) {
    const trimmed = trimHeaderField(value);
    if (trimmed) return trimmed;
  }
  return '';
};

export const resolveSubjectFromNameForSegment = (
  segNum,
  subjectFromNameRules,
  globalSubject,
  globalFromName,
) => {
  const rules = subjectFromNameRules || [];
  const globalSubjectValue = trimHeaderField(globalSubject);
  const globalFromValue = trimHeaderField(globalFromName);
  const poolSubject = firstNonEmptyHeaderField(...rules.map(rule => rule.subject));
  const poolFrom = firstNonEmptyHeaderField(...rules.map(rule => rule.from_name));
  const resolve = rule => ({
    subject: firstNonEmptyHeaderField(rule?.subject, globalSubjectValue, poolSubject),
    fromName: firstNonEmptyHeaderField(rule?.from_name, globalFromValue, poolFrom),
  });

  if (rules.length > 0) {
    for (const rule of rules) {
      const from = rule.from || 1;
      const to = rule.to || Infinity;
      if (
        segNum >= from
        && segNum <= to
        && (trimHeaderField(rule.subject) || trimHeaderField(rule.from_name))
      ) {
        return resolve(rule);
      }
    }
    return resolve(rules[rules.length - 1]);
  }

  return { subject: globalSubjectValue, fromName: globalFromValue };
};

export const generatePresetRules = (totalSegments, batchSize, preset = 'max') => {
  if (!totalSegments || !batchSize || batchSize <= 0) return [];
  const rules = [];
  const groups = Math.ceil(totalSegments / batchSize);

  for (let group = 0; group < groups; group++) {
    const from = group * batchSize + 1;
    const to = Math.min((group + 1) * batchSize, totalSegments);
    if (preset === 'max') {
      const hash = (group * 2654435761) >>> 0;
      rules.push({
        from,
        to,
        zw_subject: !!(hash & 1),
        zw_fromname: !!(hash & 2),
        zw_content: !!(hash & 4),
        zw_textpart: true,
        multipart: false,
        client_profile: VARIATION_PROFILES[group % VARIATION_PROFILES.length],
        disable_client_headers: !!(hash & 32),
      });
    } else if (preset === 'safe') {
      rules.push({
        from,
        to,
        zw_subject: true,
        zw_fromname: true,
        zw_content: false,
        zw_textpart: true,
        multipart: false,
        client_profile: VARIATION_PROFILES[group % VARIATION_PROFILES.length],
        disable_client_headers: false,
      });
    } else if (preset === 'stealth') {
      const combinations = [
        { zw_subject: true, zw_fromname: true, zw_content: false },
        { zw_subject: true, zw_fromname: false, zw_content: false },
        { zw_subject: false, zw_fromname: true, zw_content: false },
        { zw_subject: true, zw_fromname: true, zw_content: true },
        { zw_subject: false, zw_fromname: false, zw_content: false },
        { zw_subject: true, zw_fromname: false, zw_content: true },
        { zw_subject: false, zw_fromname: true, zw_content: true },
      ];
      rules.push({
        from,
        to,
        ...combinations[group % combinations.length],
        zw_textpart: true,
        multipart: false,
        client_profile: VARIATION_PROFILES[group % VARIATION_PROFILES.length],
        disable_client_headers: group % 5 === 0,
      });
    }
  }

  return rules;
};
